import { render, staticRenderFns } from "./reWorkspace.vue?vue&type=template&id=013408bd&scoped=true&"
import script from "./reWorkspace.vue?vue&type=script&lang=js&"
export * from "./reWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./reWorkspace.vue?vue&type=style&index=0&id=013408bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013408bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('013408bd')) {
      api.createRecord('013408bd', component.options)
    } else {
      api.reload('013408bd', component.options)
    }
    module.hot.accept("./reWorkspace.vue?vue&type=template&id=013408bd&scoped=true&", function () {
      api.rerender('013408bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/DestinationBusiness/detail/reWorkspace.vue"
export default component.exports